import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CpPlansProposalPlansModel } from '../../../helpers/objects/dto/client-portal/proposal/cp-plans-proposal-plans-model';
import { ProposalBillingRequestModel } from '../../../helpers/objects/request/client-portal/proposal-billing/proposal-billing-request-model';
import { ProposalBillingResponseModel } from '../../../helpers/objects/response/client-portal/proposal-billing/proposal-billing-response-model';
import { ProposalBillingSddRequestModel } from '../../../helpers/objects/request/client-portal/proposal-billing-sdd/proposal-billing-sdd-request-model';

@Injectable({
  providedIn: 'root'
})
export class CpPlansProposalService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  proposalApi: string = '';

  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
    this.proposalApi = this.appConfig.api.replace('/fhcp/', '/adhesion/');
  }

  set(proposal: CpPlansProposalPlansModel): Observable<CpPlansProposalPlansModel> {
    let headers = new HttpHeaders();
    headers = headers.set('X-AppContext', this.appConfig.apiAppContext);
    return this.http.post<any>(this.proposalApi + 'proposals', proposal, { headers }).pipe(map((response) => response.body as CpPlansProposalPlansModel));
  }

  update(id: string, token: string, proposal: CpPlansProposalPlansModel): Observable<CpPlansProposalPlansModel> {
    const headers = new HttpHeaders({
      'X-AppContext': this.appConfig.apiAppContext,
      'X-Token': token
    });
    return this.http.put<any>(this.proposalApi + 'proposals/' + id, proposal, { headers }).pipe(map((response) => response.body as CpPlansProposalPlansModel));
  }

  getBilling(token: string, body: ProposalBillingRequestModel): Observable<ProposalBillingResponseModel> {
    const headers = new HttpHeaders({
      'X-AppContext': this.appConfig.apiAppContext,
      'X-Token': token
    });

    return this.http
      .post<any>(this.proposalApi + 'proposals/' + body.id + '/billing', body, { headers })
      .pipe(map((response) => response.body as ProposalBillingResponseModel));
  }

  setBillingDetails(proposalId: number, directDebit: ProposalBillingSddRequestModel, firstPayment: string, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-AppContext': this.appConfig.apiAppContext,
      'X-Token': token
    });

    directDebit.firstPayment = {
      paymentMethodCode: firstPayment
    };

    return this.http.post<any>(this.proposalApi + 'proposals/' + proposalId + '/billing/sdd', directDebit, { headers });
  }
  getBillingDetails(proposalId: number, token: string, body:any): Observable<any> {
    const headers = new HttpHeaders({
      'X-AppContext': this.appConfig.apiAppContext,
      'X-Token': token
    });

    return this.http.post<any>(this.proposalApi + 'proposals/' + proposalId + '/billing/details', body, {headers});
  }

  get(proposalId: string, token: string): Observable<CpPlansProposalPlansModel> {
    const headers = new HttpHeaders({
      'X-AppContext': this.appConfig.apiAppContext,
      'X-Token': token
    });
    return this.http.get<any>(this.proposalApi + 'proposals/' + proposalId, { headers }).pipe(map((response) => response.body as CpPlansProposalPlansModel));
  }
}
